import { render, staticRenderFns } from "./ProductListAddVendorModal.vue?vue&type=template&id=bac4ad04"
import script from "./ProductListAddVendorModal.vue?vue&type=script&lang=js"
export * from "./ProductListAddVendorModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports